import { track } from '@amplitude/analytics-browser';
import { formatDate } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { EntityRef, Setting, SettingReviewRequest, SettingsService, SettingsUpdateRequest } from '../../core/settings/settings.service';

@Component({
  selector: 'request-review-modal',
  templateUrl: './request-review-modal.component.html',
  styleUrls: ['./request-review-modal.component.scss']
})

export class SettingsRequestReviewModalComponent implements OnInit {
  @Input() requestId!: string;
  @Input() reviewerName: string;

  settingsUpdateRequest: SettingsUpdateRequest | undefined;
  reviewed = false;
  loading = true;
  requestDate = '';
  settings: Setting[] = [];

  reviewRequestForm = new FormGroup({
    description: new FormControl('', [Validators.required])
  });
  entitiesList: EntityRef[];

  constructor(
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    private bulkSettingRequestService: SettingsService
  ) { }

  async getData(): Promise<void> {
    try {
      this.settingsUpdateRequest = await this.bulkSettingRequestService.getSettingsUpdateRequest(this.requestId);
      this.entitiesList = this.settingsUpdateRequest.entities;

      this.settings = this.settingsUpdateRequest.settings;

      this.reviewed = this.settingsUpdateRequest.status !== 'Awaiting Approval';
      this.requestDate = formatDate(this.settingsUpdateRequest.requestDate, 'short', 'en-US');
    } catch (error) {
      this.toastr.error('Failure retrieving data.');
    }
    finally {
      this.loading = false;
    }
  }

  async ngOnInit() {
    track('Control Center Settings Request View modal Loaded');
    await this.getData();
  }

  cancel() {
    this.activeModal.dismiss(false);
  }

  async review(approved: boolean) {
    this.reviewed = true;

    track('Request Reviewed',
      {
        reviewer: this.reviewerName,
        reviewDate: new Date(),
        approved: approved,
        requestId: this.requestId
      });

    const review: SettingReviewRequest = {
      approved: approved,
      reviewer: this.reviewerName,
      description: this.reviewRequestForm.controls['description'].value!
    }
    await this.bulkSettingRequestService.reviewSettingsUpdateRequest(this.requestId, review);
    this.activeModal.close(approved ? 'Approved' : 'Rejected');
  }
}
